import { useRef, type ComponentPropsWithoutRef } from "react";
import { useFormContext } from "@/lib/form/form-context";

type FormProps = Omit<ComponentPropsWithoutRef<"form">, "onSubmit">;

export function Form(props: FormProps) {
  const form = useFormContext();
  const submissionPending = useRef(false);

  async function submit() {
    try {
      await form.validate("submit");
      await form.handleSubmit();
    } finally {
      submissionPending.current = false;
    }
  }

  return (
    <form
      {...props}
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (submissionPending.current) return;
        submissionPending.current = true;
        void submit();
      }}
    />
  );
}
